import { useTheme } from '@mui/styles';

export const useDataGridCommonStyles = () => {
  const theme = useTheme();

  return {
    autoRowHeightPadding: {
      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
        py: theme.spacing(0.25),
      },
      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
        py: theme.spacing(0.5),
      },
      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
        py: theme.spacing(0.75),
      },
    },
  };
};
